import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {useSelector} from 'react-redux';

function PrivateRoute({component: Component, ...rest}) {
    let isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const isInfluenceLoggedIn = useSelector(state => state.auth.isInfluenceLoggedIn);
    const isBarLoggedIn = useSelector(state => state.auth.isBarLoggedIn);
    const isAuthenticated = () => {
        if (isLoggedIn || isInfluenceLoggedIn || isBarLoggedIn) {
            return true;
        } else {
            const {
                diningdonates_user_id,
                diningdonates_user,
                diningdonates_token,
                diningdonates_bar,
                diningdonates_bar_id,
                diningdonates_influence,
                diningdonates_influence_id
            } = localStorage;
            if (
                (diningdonates_user_id && diningdonates_user && diningdonates_token) ||
                (diningdonates_bar && diningdonates_bar_id) ||
                (diningdonates_influence && diningdonates_influence_id)
            ) {
                return true;
            }
            return false;
        }
    };


    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated() ? (
                    <Component {...props} />
                ) : (
                    <Redirect to={{pathname: '/', state: {referer: props.location}}}/>
                )}
        ></Route>
    )
};

export default PrivateRoute;